import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "border"
    }}>{`Border`}</h1>
    <p>{`Used to set border properties`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class Reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.bn</Name>
        <Output mdxType="Output">border-style: none; <br /><br />
                border-width: 0;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.ba</Name>
        <Output mdxType="Output">border-style: solid; <br /><br />
                border-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bt</Name>
        <Output mdxType="Output">border-top-style: solid; <br /><br />
                border-top-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.br</Name>
        <Output mdxType="Output">border-right-style: solid; <br /><br />
                border-right-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bb</Name>
        <Output mdxType="Output">border-bottom-style: solid; <br /><br />
                border-bottom-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bl</Name>
        <Output mdxType="Output">border-left-style: solid; <br /><br />
                border-left-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bx</Name>
        <Output mdxType="Output">border-left-style: solid; <br /><br />
                border-left-width: 1px; <br /> <br />
                border-right-style: solid; <br /><br />
                border-right-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.by</Name>
        <Output mdxType="Output">border-top-style: solid; <br /><br />
                border-top-width: 1px; <br /> <br />
                border-bottom-style: solid; <br /><br />
                border-bottom-width: 1px; <br /> <br />
                border-color: #000;
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-between flex-wrap" style={{
          width: '600px'
        }}>
      <div className="bn bg-primary-400 flex flex-middle p-4 mx-4 my-4">No Border</div>
      <div className="ba bg-primary-400 flex flex-middle p-4 mx-4 my-4">All Borders</div>
      <div className="bt bg-primary-400 flex flex-middle p-4 mx-4 my-4">Only Border Top</div>
      <div className="br bg-primary-400 flex flex-middle p-4 mx-4 my-4">Only Border right</div>
      <div className="bb bg-primary-400 flex flex-middle p-4 mx-4 my-4">Only Border bottom</div>
      <div className="bl bg-primary-400 flex flex-middle p-4 mx-4 my-4">Only Border left</div>
      <div className="bx bg-primary-400 flex flex-middle p-4 mx-4 my-4">Borders left and right</div>
      <div className="by bg-primary-400 flex flex-middle p-4 mx-4 my-4">Borders top and bottom</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="bn">No Border</div>
      <div className="ba">All Borders</div>
      <div className="bt">Only Border Top</div>
      <div className="br">Only Border right</div>
      <div className="bb">Only Border bottom</div>
      <div className="bl">Only Border left</div>
      <div className="bx">Borders left and right</div>
      <div className="by">Borders top and bottom</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "style"
    }}>{`Style`}</h2>
    <p>{`Used to set the border style.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.bs-none</Name>
        <Output mdxType="Output">border-style: none;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bs-solid</Name>
        <Output mdxType="Output">border-style: solid;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bs-dashed</Name>
        <Output mdxType="Output">border-style: dashed;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bs-dotted</Name>
        <Output mdxType="Output">border-style: dotted;
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-around" style={{
          width: '600px'
        }}>
      <div className="ba bs-none bg-primary-400 flex flex-middle p-4 mx-4">No Border style</div>
      <div className="ba bs-solid bg-primary-400 flex flex-middle p-4 mx-4">Solid Border</div>
      <div className="bt bs-solid bg-primary-400 flex flex-middle p-4 mx-4">Only Top Solid Border</div>
      <div className="ba bs-dashed bg-primary-400 flex flex-middle p-4 mx-4">Dashed Border</div>
      <div className="ba bs-dotted bg-primary-400 flex flex-middle p-4 mx-4">Dotted Border</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="bs-none">No Border Style</div>
      <div className="ba bs-solid">Solid Border</div>
      <div className="bt bs-solid">Only Top Solid Border</div>
      <div className="ba bs-dashed">Dashed Border</div>
      <div className="ba bs-dotted">Dotted Border</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "width"
    }}>{`Width`}</h2>
    <p>{`Used to set the border width. Possible values are 1,2,4 and 8.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.bw-1</Name>
        <Output mdxType="Output">border-width: 1px;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bw-2</Name>
        <Output mdxType="Output">border-width: 2px;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bw-4</Name>
        <Output mdxType="Output">border-width: 4px;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bw-8</Name>
        <Output mdxType="Output">border-width: 8px;
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-2"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-around" style={{
          width: '600px'
        }}>
      <div className="ba bw-1 bg-primary-400 flex flex-middle p-4 mx-4">1px Border Width</div>
      <div className="ba bw-2 bg-primary-400 flex flex-middle p-4 mx-4">2px Border Width</div>
      <div className="ba bw-4 bg-primary-400 flex flex-middle p-4 mx-4">4px Border Width</div>
      <div className="bx bw-4 bg-primary-400 flex flex-middle p-4 mx-4">4px Border Width on left and right</div>
      <div className="ba bw-8 bg-primary-400 flex flex-middle p-4 mx-4">8px Border Width</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="ba bw-1">...</div>
      <div className="ba bw-2">...</div>
      <div className="ba bw-4">...</div>
      <div className="bx bw-4">...</div>
      <div className="ba bw-8">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "border-radius"
    }}>{`Border Radius`}</h2>
    <p>{`Used to set the border radius. Possible values are : 0,2,3 and 100.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.br-0</Name>
        <Output mdxType="Output">border-radius: 0px
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.br-2</Name>
        <Output mdxType="Output">border-radius: 2px;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.btr-2</Name>
        <Output mdxType="Output">border-top-left-radius: 2px;<br /> <br />
                border-top-right-radius: 2px;<br /> <br />
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.bbr-2</Name>
        <Output mdxType="Output">border-bottom-left-radius: 2px;<br /> <br />
                border-bottom-right-radius: 2px;<br /> <br />
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.blr-2</Name>
        <Output mdxType="Output">border-top-left-radius: 2px;<br /> <br />
                border-bottom-left-radius: 2px;<br /> <br />
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.brr-2</Name>
        <Output mdxType="Output">border-top-right-radius: 2px;<br /> <br />
                border-bottom-right-radius: 2px;<br /> <br />
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-3"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-around" style={{
          width: '600px'
        }}>
      <div className="ba br-0 bg-primary-400 flex flex-middle p-4 mx-4">No border radius</div>
      <div className="ba br-100 bg-primary-400 flex flex-middle p-4 mx-4">100px border radius</div>
      <div className="ba btr-2 bg-primary-400 flex flex-middle p-4 mx-4">2px Top left and right border radius</div>
      <div className="ba bbr-2 bg-primary-400 flex flex-middle p-4 mx-4">2px Bottom left and right border radius</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="ba br-0">...</div>
      <div className="ba br-100">...</div>
      <div className="ba btr-2">...</div>
      <div className="ba bbr-2">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "border-color"
    }}>{`Border Color`}</h2>
    <p>{`Used to set the border color. The syntax is `}<inlineCode parentName="p">{`.bc-{palette}-{shade}`}</inlineCode>{`.`}</p>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.bc-secondary-400</Name>
        <Output mdxType="Output">border-color: #6290E0;
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example-4"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start" style={{
          width: '600px'
        }}>
      <div className="ba bc-secondary-400 bg-neutral-100 flex flex-middle p-4 mx-4">Colored border</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="ba bc-secondary-400">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      